  // import { Component, Input } from "@angular/core";
  // import { CommonModule } from "@angular/common";
  // import { MatCheckboxModule } from "@angular/material/checkbox";
  // import { MatIconModule } from "@angular/material/icon";
  // import { FormsModule } from "@angular/forms";

  // @Component({
  //   selector: "app-navigation-menu",
  //   imports: [CommonModule, MatCheckboxModule, MatIconModule, FormsModule],
  //   templateUrl: "./navigation-menu.component.html",
  //   styleUrl: "./navigation-menu.component.scss",
  // })
  // export class NavigationMenuComponent {
  //   @Input() selectedMenu!: any;

  //   onSortMenu(type: string, value: boolean, MasterList: any[]) {
  //     (function sortMenu(ChildList) {
  //       for (let i = 0; i < ChildList?.length; i++) {
  //         if (type === "canAdd") {
  //           ChildList[i].canAdd = value;
  //         } else if (type === "canEdit") {
  //           ChildList[i].canEdit = value;
  //         } else {
  //           ChildList[i].canDelete = value;
  //         }
  //         if (ChildList[i].ChildList?.length > 0) {
  //           sortMenu(ChildList[i].ChildList);
  //         }
  //       }
  //     })(MasterList);
  //   }

  //   UpdateAllMenus(event: any, type: string, MasterList: any[]) {
  //     const IsActive = event.checked;
  //     this.onSortMenu(type, IsActive, MasterList);
  //   }
  // }

  import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
  import { CommonModule } from "@angular/common";
  import { FormsModule } from "@angular/forms";
  import { SanitizerPipe } from "../../../pipes/sanitizer.pipe";
  import { SVG_ICONS } from "@frontend/app/models/icons";

  interface MenuItem {
    expanded?: boolean;
    MenuName: string;
    RouterPath: string;
    canAdd: boolean;
    canEdit: boolean;
    canDelete: boolean;
    ChildList?: MenuItem[];
  }
  import { trigger, state, style, transition, animate } from "@angular/animations";

  @Component({
    selector: "app-navigation-menu",
    standalone: true,
    imports: [CommonModule, FormsModule, SanitizerPipe],
    templateUrl: "./navigation-menu.component.html",
    styleUrls: ["./navigation-menu.component.scss"],
    animations: [
      trigger("indicatorRotate", [
        state("collapsed", style({ transform: "rotate(0deg)" })),
        state("expanded", style({ transform: "rotate(180deg)" })),
        transition("expanded <=> collapsed", animate("225ms cubic-bezier(0.4,0.0,0.2,1)")),
      ]),
    ],
  })
  export class NavigationMenuComponent implements OnChanges {
    readonly SVG_ICONS = SVG_ICONS;
    @Input() selectedMenu!: any;
    @Input() IsReadOnly = false;

    toggleExpanded(item: MenuItem) {
      item.expanded = !item.expanded;
    }

    isExpanded(item: MenuItem): boolean {
      return item.expanded || false;
    }

    ngOnChanges() {
      this.initializeMenuPermissions();
    }

    private initializeMenuPermissions() {

      if (this.selectedMenu) {
        this.selectedMenu.forEach((menu: any) => this.setMenuPermissions(menu));
      }
    }

    private setMenuPermissions(menu: any) {
      if (menu.MenuWithPermissions && menu.MenuWithPermissions.length > 0) {
        const permissions = menu.MenuWithPermissions[0];
        menu.canAdd = permissions.CanAdd;
        menu.canEdit = permissions.CanEdit;
        menu.canDelete = permissions.CanDelete;
      } else {
        menu.canAdd = false;
        menu.canEdit = false;
        menu.canDelete = false;
      }

      if (menu.ChildList?.length > 0) {
        menu.ChildList.forEach((child: any) => this.setMenuPermissions(child));
      }
    }

    onSortMenu(type: string, value: boolean, MasterList: any[]) {
      (function sortMenu(ChildList) {
        for (let i = 0; i < ChildList?.length; i++) {
          if (type === "canAdd") {
            ChildList[i].canAdd = value;
          } else if (type === "canEdit") {
            ChildList[i].canEdit = value;
          } else {
            ChildList[i].canDelete = value;
          }
          if (ChildList[i].ChildList?.length > 0) {
            sortMenu(ChildList[i].ChildList);
          }
        }
      })(MasterList);
    }

    UpdateAllMenus(event: any, type: string, MasterList: any[]) {
      const IsActive = event.target.checked;
      this.onSortMenu(type, IsActive, MasterList);
    }
  }
